import React, { ReactNode } from "react";

interface PrefixFieldProps {
    prefix: ReactNode;
    children: ReactNode;
}

export const PrefixField = ({ prefix, children }: PrefixFieldProps) => {
    return (
        <div className="relative flex items-center">
            {children}
            <div className="absolute left-3 top-1/2 -translate-y-1/2 transform">{prefix}</div>
        </div>
    );
};
